import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _ProductGetter = Getter.of();
export const _ProductResponseGetter = Getter.of();
export const _ProductsGetter = Getter.of();
export const _ProductsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ProductsResponse2Products = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _ProductResponse2Product = Fold.compose(_ProductResponseGetter, _Response2ResponseData());
export const _Product2Attributes = Fold.compose(_ProductGetter, Res._Response(), Lens.prop("attributes"));
export const _ProductAttributes2Alias = Fold.compose(_Product2Attributes, Lens.prop("alias"));
export const _ProductAttributes2Name = Fold.compose(_Product2Attributes, Lens.prop("name"));
export const _ProductAttributes2CampaignsExist = Fold.compose(_Product2Attributes, Lens.prop("campaignsExist"));
export const _Product2Package = Fold.compose(_ProductGetter, Res._Rel("package"), Res._ForEach());
export const _Product2PricePlan = Fold.compose(_ProductGetter, Res._Rel("pricePlan"), Res._ForEach());
export const _Product2Body = Fold.compose(_ProductGetter, Res._Rel("body"), Res._ForEach());

